import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { Observable, from, throwError } from 'rxjs';
import { catchError, switchMap } from 'rxjs/operators';
import { AccountService } from 'src/app/services/account.service';

// Body the API returns when the user is authenticated but lacks the endpoint permission
type PermissionDeniedBody = {
  success: false;
  text: string;
}

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private accountService: AccountService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(catchError(err => {
      if ([401, 403].includes(err.status) && this.accountService.userValue.token) {
        return from(this.readBody(err.error)).pipe(switchMap(body => {
          if (this.isPermissionDenied(body)) {
            // the session is still valid, only the permission is missing
            return throwError(() => body.text);
          }
          // auto logout if 401 or 403 response returned from api
          this.accountService.logout();
          return throwError(() => err.error?.message || err.statusText);
        }));
      }

      const error = err.error?.message || err.statusText;
      return throwError(() => error);
    }));
  }

  // downloads use responseType 'blob', so their error body arrives as a Blob
  private async readBody(error: any): Promise<any> {
    if (error instanceof Blob) {
      try {
        return JSON.parse(await error.text());
      } catch {
        return null;
      }
    }
    return error;
  }

  private isPermissionDenied(body: any): body is PermissionDeniedBody {
    return body?.success === false;
  }
}
